export class ActionList {
  id: string;
  name: string;
  modified: Date;
  accounts: number;
  inProgress: boolean;

  constructor(data: any) {
    Object.assign(this, data);
  }
}
